import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipProgram, TipProgramUpdate } from './tip-program.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TipProgramService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getTipuriProgramUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.getTipuriProgram;
    private getTipuriProgramActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.getTipuriProgramActive;
    private getTipuriProgramPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.getTipuriProgramPublic;
    private storeTipProgramUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.storeTipProgram;
    private updateTipProgramUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.updateTipProgram;
    private deleteTipProgramUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.deleteTipProgram;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.changeStatusTipProgramActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProgram.changeStatusTipProgramPublic;

    constructor(private http: HttpClient) { }

    addTipProgram(tipProgram: TipProgram) {
        return this.http.post(this.storeTipProgramUrl, tipProgram, this.httpOptions);
    }

    updateTipProgram(tipProgram: TipProgramUpdate) {
        return this.http.put(this.updateTipProgramUrl, tipProgram, this.httpOptions);
    }

    deleteTipProgram(id: number) {
        return this.http.delete(this.deleteTipProgramUrl + id);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getTipuriProgram() {
        return this.http.get(this.getTipuriProgramUrl, this.httpOptions);
    }

    getTipuriProgramActive() {
        return this.http.get(this.getTipuriProgramActiveUrl, this.httpOptions);
    }

    getTipuriProgramPublic() {
        return this.http.get(this.getTipuriProgramPublicUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
